export default {
  BusinessReportSaleShop: {
    orderTime: 'Order time',
    storeType: 'Store type',
    organization: 'Affiliated company',
    storeName: 'Store name',
    storeCode: 'Store code',
    storeTypeCode: 'Store type',
    orderCount: 'Order count',
    orderAmount: 'Sales amount',
    reverseOrderCount: 'Refund order count',
    reverseOrderAmount: 'Refund amount',
  }
};
